import { render, staticRenderFns } from "./workersTable.vue?vue&type=template&id=588040cc&"
import script from "./workersTable.vue?vue&type=script&lang=ts&"
export * from "./workersTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports